import { render, staticRenderFns } from "./loginHeader.vue?vue&type=template&id=6edf94e9&"
import script from "./loginHeader.vue?vue&type=script&lang=js&"
export * from "./loginHeader.vue?vue&type=script&lang=js&"
import style0 from "./loginHeader.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports